export default function UpdatesSection() {
  const updates = [
    {
      id: 1,
      date: '2026.07.29',
      title: '《星辰变》第六季第12话更新',
      tag: '新番更新',
      desc: '秦羽在神界遭遇新挑战，剧情进入白热化阶段，本话战斗场面为全季之最。',
    },
    {
      id: 2,
      date: '2026.07.28',
      title: '《斗破苍穹》年番第156话上线',
      tag: '年番更新',
      desc: '萧炎炼药大会决战，丹雷引发天地异象，各方势力蠢蠢欲动。',
    },
    {
      id: 3,
      date: '2026.07.27',
      title: '《一念永恒》第三季定档8月15日',
      tag: '定档公告',
      desc: '官方发布第三季先导PV，白小纯全新造型曝光，粉丝期待值拉满。',
    },
    {
      id: 4,
      date: '2026.07.26',
      title: '2026国漫暑期档总播放量破100亿',
      tag: '行业动态',
      desc: '本年度暑期档国产动漫播放数据再创新高，多部作品贡献亮眼成绩。',
    },
    {
      id: 5,
      date: '2026.07.25',
      title: '《完美世界》特别篇制作决定发布',
      tag: '特别企划',
      desc: '官方宣布将制作石昊回忆篇特别篇，预计年底上线，制作团队原班人马。',
    },
    {
      id: 6,
      date: '2026.07.24',
      title: '《凡人修仙传》荣获国际动画奖项',
      tag: '获奖喜讯',
      desc: '凡人修仙传凭借精湛的3D制作技术斩获亚洲动漫大奖最佳视觉效果奖。',
    },
    {
      id: 7,
      date: '2026.07.23',
      title: '《仙王的日常生活》第四季首播破亿',
      tag: '数据捷报',
      desc: '第四季首周播放量突破1亿次，延续系列高人气，新角色广受好评。',
    },
    {
      id: 8,
      date: '2026.07.22',
      title: '51动漫网暑期专题页面全新上线',
      tag: '平台公告',
      desc: '51动漫官网推出暑期特别专题，聚合暑期档全部热播动漫，一页尽览。',
    },
  ];

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            51动漫持续追踪国产动漫最新资讯与番剧更新动态
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
            {updates.map((update) => (
              <div key={update.id} className="relative mb-8 last:mb-0">
                <div className="absolute -left-[25px] md:-left-[29px] top-1 w-3 h-3 bg-primary-500 rounded-full border-2 border-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="flex-shrink-0 text-xs font-medium text-foreground-500 bg-background-200/70 px-2.5 py-1 rounded-md inline-block w-fit">
                    {update.date}
                  </span>
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-2 mb-1.5">
                      <h3 className="font-heading text-base md:text-lg text-foreground-950">
                        {update.title}
                      </h3>
                      <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">
                        {update.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {update.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}